import React, { FC } from 'react';
import { Text, View } from 'react-native';

import { Theme } from '@constants';

import { styles } from './styles';

export const CaptionsDisplayTestIds = {
  container: 'CaptionsDisplayContainer',
  text: 'CaptionsDisplayContainerText',
};

export const CaptionsDisplay: FC<CaptionsDisplayProps> = ({ enabled, caption, width }) => (
  <>
    {enabled && caption !== '' && (
      <View style={styles.container} testID={CaptionsDisplayTestIds.container}>
        <Text
          style={[styles.text, { fontSize: (Theme.px(50) * width) / Theme.appWidth }]}
          testID={CaptionsDisplayTestIds.text}
        >
          {caption}
        </Text>
      </View>
    )}
  </>
);

export type CaptionsDisplayProps = {
  enabled: boolean;
  caption: string;
  width: number;
};
